<template>
  <div>
    <div class="create-talent-drawer">
      <el-drawer :title="title"
                 :visible.sync="drawer"
                 :wrapperClosable="false"
                 :close-on-press-escape="false"
                 direction="rtl"
                 @close="colseDrawer">
        <el-tabs v-model="activeName"
                 @tab-click="handleClick">
          <el-tab-pane label="基本信息"
                       name="first">
            <div class="base">
              <!-- <div class="add-item-title" style="margin-top: 0">基本信息</div> -->
              <el-form ref="form"
                       :inline="true"
                       :model="form"
                       :rules="rules"
                       label-width="120px"
                       size="mini"
                       v-enterToNext="true">
                <div style="display: flex; justify-content: space-between">
                  <div class="form-left">
                    <el-form-item v-if="operation=='add'"
                                  label="同步入职"
                                  class="form-item-block">
                      <el-checkbox v-model="employment">是</el-checkbox>
                    </el-form-item>
                    <div class="avatar-box">
                      <el-upload class="avatar-uploader"
                                 action=""
                                 accept=".jpg,.png"
                                 :show-file-list="false"
                                 ref="uploadComapnayLogo"
                                 :http-request="uploadComapnayLogo">
                        <img :src="
                            form.logo[0]
                              ? form.logo[0].url
                              : require('../../assets/img/avatar.png')
                          "
                             class="avatar" />
                        <span style="color: #4380fb">更改头像</span>
                      </el-upload>
                    </div>
                    <div class="formBox">
                      <el-form-item label="姓名"
                                    prop="cname">
                        <el-input v-model="form.cname"
                                  maxlength="20"
                                  :style="type != 0 ? 'width: 60%' : 'width: 100%'"
                                  placeholder="请输入姓名"></el-input>
                        <span v-if="type != 0"
                              style="
                            text-decoration: underline;
                            cursor: pointer;
                            color: #409eff;
                            margin-left: 8px;
                          "
                              @click="addPersonnel">
                          已有人员
                        </span>
                      </el-form-item>
                      <el-form-item label="身份证号"
                                    prop="identityCard">
                        <el-input v-model="form.identityCard"
                                  maxlength="18"
                                  placeholder="请输入身份证号"
                                  @input="writeIdCard"></el-input>
                      </el-form-item>

                      <!-- <el-form-item label="手机号码" prop="tel">
                        <el-input
                          v-model="form.tel"
                          maxlength="11"
                          placeholder="请输入手机号码"
                          :disabled="operation == 'edit'"
                        ></el-input>
                      </el-form-item> -->
                      <el-form-item label="手机号码"
                                    prop="tel">
                        <el-input v-model="form.tel"
                                  :disabled="telFlag"
                                  maxlength="11"
                                  placeholder="请输入手机号码"></el-input>
                      </el-form-item>
                      <el-form-item label="性别"
                                    prop="sex">
                        <el-radio-group v-model="form.sex">
                          <el-radio :label="'男'">男</el-radio>
                          <el-radio :label="'女'">女</el-radio>
                        </el-radio-group>
                      </el-form-item>
                      <el-form-item label="人员状态">
                        <el-select v-model="form.state"
                                   clearable
                                   style="width: 100%"
                                   placeholder="请选择状态">
                          <el-option v-for="item in statusList"
                                     :key="item.Value"
                                     :label="item.value"
                                     :value="item.num"></el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item label="籍贯">
                        <el-cascader v-model="form.nativePlace"
                                     :options="options"
                                     clearable
                                     :props="{ expandTrigger: 'click' }"
                                     ref="cascaderItem"
                                     @change="chooseArea"
                                     style="width: 100%"></el-cascader>
                      </el-form-item>

                      <el-form-item label="户口所在地">
                        <el-input v-model="form.permanentResidence"
                                  maxlength="20"
                                  placeholder="请输入户口所在地"></el-input>
                      </el-form-item>
                    </div>
                    <div class="formBox">
                      <el-form-item label="紧急联系人">
                        <el-input v-model="form.emergencyContact"
                                  placeholder="请输入紧急联系人"
                                  maxlength="11"></el-input>
                      </el-form-item>

                      <el-form-item label="紧急手机号码"
                                    prop="emergencyContactTel">
                        <el-input v-model="form.emergencyContactTel"
                                  placeholder="请输入紧急手机号码"
                                  maxlength="11"></el-input>
                      </el-form-item>
                      <el-form-item label="文化程度">
                        <el-select filterable
                                   v-model="form.basicinformation"
                                   clearable
                                   style="width: 100%"
                                   placeholder="请选择文化程度">
                          <el-option v-for="item in basicinformationList"
                                     :key="item.name"
                                     :label="item.name"
                                     :value="item.name"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="退役军人">
                        <el-radio-group v-model="form.isVeteran">
                          <el-radio :label="true">是</el-radio>
                          <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                      </el-form-item>
                      <el-form-item label="收入情况"
                                    prop="income">
                        <div style="width: 70%; display: inline-block">
                          <input-number-range :precision="2"
                                              v-model="form.income"></input-number-range>
                        </div>
                        元/月
                      </el-form-item>

                      <el-form-item label="备注"
                                    prop="remark">
                        <el-input type="textarea"
                                  rows="2"
                                  v-model="form.remark"
                                  placeholder="请输入备注"></el-input>
                      </el-form-item>

                    </div>
                    <div v-if="operation=='add'">
                      <div class="formBox"
                           style="margin-top: 10px"
                           v-if="employment">
                        <el-form-item label="入职单位"
                                      prop="userOnJobRecord.factoryId">
                          <el-select filterable
                                     v-model="form.userOnJobRecord.factoryId"
                                     clearable
                                     style="width: 60%"
                                     placeholder="请选择入职单位"
                                     @change="PositionList"
                                     ref="entryFactoryId">
                            <el-option v-for="item in companyList"
                                       :key="item.id"
                                       :label="item.customerName"
                                       :value="item.id"></el-option>
                          </el-select>
                          <span style="
                            text-decoration: underline;
                            cursor: pointer;
                            color: #409eff;
                            margin-left: 8px;
                          "
                                @click="addCustomerDrawerShow = true">
                            新增
                          </span>
                        </el-form-item>
                        <el-form-item label="职位"
                                      prop="userOnJobRecord.factoryId"
                                      v-if="form.userOnJobRecord.factoryId">
                          <el-select filterable
                                     v-model="form.userOnJobRecord.positionId"
                                     ref="entryPositionId"
                                     clearable
                                     @change="handleChange()"
                                     style="width: 60%"
                                     placeholder="请先选择单位">
                            <el-option v-for="item in positionList"
                                       :key="item.id"
                                       :label="item.positionName"
                                       :value="item.id"></el-option>
                          </el-select>
                          <span style="
                            text-decoration: underline;
                            cursor: pointer;
                            color: #409eff;
                            margin-left: 8px;
                          "
                                @click="addPositionDrawerShow = true">
                            新增
                          </span>
                        </el-form-item>
                        <div v-if="form.userOnJobRecord.positionId">
                          <el-form-item label="入职时间">
                            <el-date-picker v-model="form.userOnJobRecord.entryDate"
                                            type="date"
                                            value-format="yyyy-MM-dd"
                                            placeholder="选择日期">
                            </el-date-picker>
                          </el-form-item>
                          <el-form-item label="入职手机号"
                                        prop="userOnJobRecord.tel">
                            <el-input v-model="form.userOnJobRecord.tel"
                                      maxlength="11"
                                      placeholder="请输入手机号码"></el-input>
                          </el-form-item>
                          <el-form-item label="发薪银行名称"
                                        prop="tel">
                            <el-input v-model="form.userOnJobRecord.wageCardName"
                                      maxlength="11"
                                      placeholder="请输入银行名称"></el-input>
                          </el-form-item>
                          <el-form-item label="发薪银行卡号"
                                        prop="wageCardNum">
                            <el-input v-model="form.userOnJobRecord.wageCardNum"
                                      maxlength="20"
                                      placeholder="请输入银行卡号"></el-input>
                          </el-form-item>
                          <el-form-item label="工厂结算"
                                        prop="userOnJobRecord.wages1">
                            <el-input v-model="form.userOnJobRecord.wages1"
                                      placeholder="请输入工厂结算"
                                      maxlength="30">
                              <template slot="append">{{remunerationTypeJudge()}}</template></el-input></el-form-item>
                          <el-form-item label="公司报价"
                                        prop="userOnJobRecord.wages2">
                            <el-input v-model="form.userOnJobRecord.wages2"
                                      placeholder="请输入公司报价"
                                      maxlength="30">
                              <template slot="append">{{remunerationTypeJudge()}}</template></el-input></el-form-item>

                          <el-form-item label="员工工资"
                                        prop="userOnJobRecord.wages3">
                            <el-input v-model="form.userOnJobRecord.wages3"
                                      placeholder="请输入员工工资"
                                      maxlength="30">
                              <template slot="append">{{remunerationTypeJudge()}}</template></el-input></el-form-item>
                          <el-form-item label="工头佣金">
                            <el-input v-model="form.userOnJobRecord.commission"
                                      placeholder="请输入工头佣金"
                                      maxlength="30">
                              <template slot="append">{{remunerationTypeJudge()}}</template></el-input></el-form-item>
                          <el-form-item label="员工奖金">
                            <el-input v-model="form.userOnJobRecord.bonus"
                                      placeholder="请输入员工奖金"
                                      maxlength="30">
                              <template slot="append">元</template></el-input></el-form-item>
                          <el-form-item label="员工扣除">
                            <el-input v-model="form.userOnJobRecord.deductMoney"
                                      placeholder="请输入员工扣除"
                                      maxlength="30">
                              <template slot="append">元</template></el-input></el-form-item>

                        </div>
                      </div>
                    </div>
                    <div class="formBox"
                         v-else>
                      <el-form-item label="在职单位">
                        <el-select filterable
                                   v-model="form.entryFactoryId"
                                   clearable
                                   style="width: 60%"
                                   placeholder="请选择在职单位"
                                   @change="PositionList"
                                   ref="entryFactoryId">
                          <el-option v-for="item in companyList"
                                     :key="item.id"
                                     :label="item.customerName"
                                     :value="item.id"></el-option>
                        </el-select>
                        <span style="
                            text-decoration: underline;
                            cursor: pointer;
                            color: #409eff;
                            margin-left: 8px;
                          "
                              @click="addCustomerDrawerShow = true">
                          新增
                        </span>
                      </el-form-item>
                      <el-form-item label="职位"
                                    v-if="form.entryFactoryId">
                        <el-select filterable
                                   v-model="form.entryPositionId"
                                   ref="entryPositionId"
                                   clearable
                                   @change="handleChange()"
                                   style="width: 60%"
                                   placeholder="请先选择单位">
                          <el-option v-for="item in positionList"
                                     :key="item.id"
                                     :label="item.positionName"
                                     :value="item.id"></el-option>
                        </el-select>
                        <span style="
                            text-decoration: underline;
                            cursor: pointer;
                            color: #409eff;
                            margin-left: 8px;
                          "
                              @click="addPositionDrawerShow = true">
                          新增
                        </span>
                      </el-form-item>
                      <el-form-item label="备注"
                                    prop="remark">
                        <el-input type="textarea"
                                  rows="2"
                                  v-model="form.remark"
                                  placeholder="请输入备注"></el-input>
                      </el-form-item>

                      <el-form-item label="收入情况"
                                    prop="income">
                        <div style="width: 70%; display: inline-block">
                          <input-number-range :precision="2"
                                              v-model="form.income"></input-number-range>
                        </div>
                        元/月
                      </el-form-item>
                      <el-row>
                        <el-form-item label="入职时间">
                          <el-date-picker v-model="form.entryDate"
                                          type="date"
                                          value-format="yyyy-MM-dd"
                                          placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                      </el-row>

                    </div>
                  </div>
                  <div class="form-right">
                    <el-col :span="24">
                      <el-form-item label="身份证正面"
                                    prop="identityCardFrontPath"
                                    style="width: 100%">
                        <el-upload :class="{ 'hide-upload': isHideIdCardFrontUpload }"
                                   action=""
                                   :limit="1"
                                   accept=".jpg,.png"
                                   :file-list="form.identityCardFrontPath"
                                   list-type="picture-card"
                                   :on-preview="onPreview"
                                   :before-remove="removeUploadIdCardFront"
                                   ref="uploadIdCardFont"
                                   :http-request="uploadIdCardFont">
                          <i class="el-icon-plus"></i>
                          <div slot="tip"
                               class="el-upload__tip">
                            请上传.jpg/.png格式文件，文件大小不超过10M
                          </div>
                        </el-upload>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="身份证反面"
                                    prop="identityCardBackPath"
                                    style="width: 100%">
                        <el-upload :class="{ 'hide-upload': isHideIdCardBackUpload }"
                                   action=""
                                   :limit="1"
                                   accept=".jpg,.png"
                                   :file-list="form.identityCardBackPath"
                                   list-type="picture-card"
                                   :on-exceed="onExceed"
                                   :on-preview="onPreview"
                                   ref="uploadIdCardBack"
                                   :before-remove="removeUploadIdCardBack"
                                   :http-request="uploadIdCardBack">
                          <i class="el-icon-plus"></i>
                          <div slot="tip"
                               class="el-upload__tip">
                            请上传.jpg/.png格式文件，文件大小不超过10M
                          </div>
                        </el-upload>
                      </el-form-item>
                    </el-col>
                  </div>
                </div>
                <!-- <el-form-item label="居住地址">
                <el-input v-model="form.unitAddress" maxlength="20"></el-input>
              </el-form-item> -->

                <el-col :span="24"
                        style="padding-bottom: 70px">
                  <!-- <div class="hover-tip">上传头像</div> -->
                  <!-- </el-upload>
                    <el-upload
                      :class="{ 'hide-upload': isHideLogoUpload }"
                      action=""
                      :limit="1"
                      :file-list="form.logo"
                      list-type="picture-card"
                      :on-exceed="onExceed"
                      :on-preview="onPreview"
                      :before-remove="removeUploadLogo"
                      ref="uploadComapnayLogo"
                      :http-request="uploadComapnayLogo"
                    >
                      <i class="el-icon-plus"></i>
                      <div slot="tip" class="el-upload__tip">
                        请上传.jpg/.png格式文件，文件大小不超过5M
                      </div>
                    </el-upload> -->
                </el-col>
              </el-form>
            </div>

            <div class="submit-bar">
              <el-button @click="
                  () => {
                    colseDrawer();
                  }
                ">关 闭</el-button>
              <el-button type="primary"
                         @click="onSubmit">保 存</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane label="银行卡信息"
                       name="second"
                       v-if="operation != 'add'">
            <div class="wrapper">
              <div class="row optional"></div>
              <div class="row table">
                <div style="text-align: right">
                  <el-button size="small"
                             type="primary"
                             plain
                             @click="addAccount"
                             icon="el-icon-plus">新增</el-button>
                </div>

                <MyTable :tableData="tableData"
                         :tableConfig="tableConfig"
                         :height="tableHeight"
                         ref="cardForm"
                         :indexFlag="true"
                         tableEmptyText="暂无数据，点击新增"
                         @EmptyBtn="addAccount">
                  <template v-slot:index="slotData">
                    {{
                      ($refs.pagination.currentPage - 1) *
                        $refs.pagination.pageSize +
                      slotData.scope.$index +
                      1
                    }}
                  </template>
                  <template v-slot:isDefault="slotData">
                    {{ slotData.scope.row.isDefault ? "是" : "否" }}
                  </template>
                  <template v-slot:isOpenInPlatform="slotData">
                    {{ slotData.scope.row.isOpenInPlatform ? "是" : "否" }}
                  </template>
                  isLogout
                  <template v-slot:isLogout="slotData">
                    <el-tag v-if="slotData.scope.row.isLogout == true"
                            type="info"
                            size="mini">
                      注销</el-tag>
                    <el-tag v-else
                            type="success"
                            size="mini"> 正常</el-tag>
                  </template>
                  <template v-slot:imgPath="slotData">
                    <el-image v-if="slotData.scope.row.imgPath"
                              style="width: 100px; height: 70px"
                              :src="slotData.scope.row.imgPath"
                              fit="fill"
                              :preview-src-list="[slotData.scope.row.imgPath]"></el-image>
                  </template>
                  <template v-slot:operation="slotData">
                    <el-button @click="setDefault(slotData.scope.row)"
                               class="chabtn"
                               size="small"
                               icon="el-icon-edit"
                               v-if="!slotData.scope.row.isLogout">设为工资卡</el-button>
                    <el-button @click="deleteCustomer(slotData.scope.row)"
                               type="danger"
                               plain
                               size="small"
                               icon="el-icon-delete"
                               v-if="!slotData.scope.row.isOpenInPlatform"
                               v-show="!slotData.scope.row.isLogout">注销</el-button>
                  </template>
                </MyTable>

                <Pagination style="margin-top: 10px"
                            :total="total"
                            @getNewData="getTalentList"
                            ref="pagination" />
              </div>

              <div class="submit-bar">
                <el-button @click="
                    () => {
                      colseDrawer();
                    }
                  ">关 闭</el-button>
                <!-- <el-button
            type="primary"
            :loading="submitLoading"
            @click="onSubmit('form')"
            >确定</el-button
          > -->
              </div>
            </div>
            <el-dialog title="新增银行卡"
                       :visible.sync="dialogVisible"
                       :close-on-click-modal="false"
                       :close-on-press-escape="false"
                       :append-to-body="true"
                       width="660px"
                       @close="resetForm('cardForm')">
              <el-form ref="cardForm"
                       :model="form"
                       :rules="rules"
                       v-enterToNext="true">
                <div style="display: flex; justify-content: space-between">
                  <div style="width: 48%">
                    <el-form-item label="银行卡号"
                                  prop="cardNum">
                      <el-input v-model="form.cardNum"
                                maxlength="19"
                                @input="cardInput"
                                placeholder="请输入银行卡号"></el-input>
                    </el-form-item>
                    <el-form-item label="开户银行"
                                  prop="openingBank">
                      <el-select filterable
                                 v-model="form.openingBank"
                                 style="width: 100%"
                                 placeholder="请选择开户银行"
                                 ref="batchSelect">
                        <el-option v-for="item in BankList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.name"></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="开户姓名"
                                  prop="openingBankName">
                      <el-input v-model="form.openingBankName"
                                disabled></el-input>
                    </el-form-item>
                  </div>
                  <div style="
                      width: 48%;
                      border-left: 1px solid #e4e7ed;
                      padding-left: 20px;
                    ">
                    <el-col :span="24"
                            class="imgPath">
                      <el-form-item label="银行卡照片"
                                    prop="identityCardFrontPath"
                                    style="width: 100%">
                        <el-upload :class="{ 'hide-upload': isHideimgPathUpload }"
                                   action=""
                                   :limit="1"
                                   accept=".jpg,.png"
                                   :file-list="form.imgPath"
                                   list-type="picture-card"
                                   :on-preview="onPreview"
                                   :before-remove="removeUploadimgPath"
                                   ref="uploadimgPath"
                                   :http-request="uploadimgPath">
                          <i class="el-icon-plus"></i>
                          <div slot="tip"
                               class="el-upload__tip">
                            请上传.jpg/.png格式文件，文件大小不超过10M
                          </div>
                        </el-upload>
                      </el-form-item>
                    </el-col>
                  </div>
                </div>
              </el-form>
              <div style="color: #e6a23c">
                请仔细核对银行卡信息，避免财务往来，或工资发放产生错误！由于此信息出现的资金支付或收款错误，本系统将不承担任何责任。
              </div>
              <span slot="footer"
                    class="dialog-footer">
                <el-button @click="
                    () => {
                      resetForm('cardForm');
                      dialogVisible = false;
                    }
                  ">关 闭</el-button>
                <el-button size="small "
                           type="primary"
                           @click="imgEdit('cardForm')">确 定</el-button>
              </span>
            </el-dialog>
          </el-tab-pane>
        </el-tabs>
        <div class="rightPadding"></div>
      </el-drawer>
      <el-dialog :visible.sync="imgDialog.show">
        <img width="100%"
             :src="imgDialog.url"
             alt="" />
      </el-dialog>
      <el-dialog title="提示"
                 :visible.sync="tipVisible"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false"
                 width="700px"
                 @close="closeDialog">
        <div class="tip">
          确认发送开卡通知吗?您也可以直接将下述二维码转发给对方，进行开卡。如您打算使用其它通知，请勾选其它通知。
          <div v-for="item in bankInfoList"
               :key="item.bankId">
            <div style="margin-top: 10px; display: flex">
              {{ item.bankName }} &nbsp;
              <img style="width: 140px"
                   :src="item.imgPath"
                   alt=""
                   v-if="$shareType == 2" />
              <div :id="item.bankName"
                   :ref="item.bankName"
                   v-if="$shareType == 1"></div>
            </div>
          </div>
          <div class="checkGroup">
            <el-checkbox-group v-model="checkboxGroup"
                               size="small">
              <el-checkbox label="1"
                           border
                           disabled>小程序内通知</el-checkbox>
              <el-checkbox label="2"
                           border>短信通知</el-checkbox>
              <el-checkbox label="3"
                           border>小程序订阅通知</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="
              () => {
                resetForm('form');
                tipVisible = false;
              }
            ">关 闭</el-button>
          <el-button size="small "
                     type="primary"
                     @click="sendNotic('form')">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <AddPosition :drawerShow="addPositionDrawerShow"
                 operation="add"
                 title="新增职位"
                 @colseDrawer="addPositionDrawerShow = false"
                 @refreshData="PositionList" />
    <addCardList @colseDrawer="(addCardShow = false), colseDrawer()"
                 :visible.sync="addCardShow"
                 :row="onerow" />
    <AddCustomer :drawerShow="addCustomerDrawerShow"
                 operation="add"
                 title="新增企业/客户"
                 @colseDrawer="addCustomerDrawerShow = false"
                 @refreshData="getCompanyList" />
  </div>
</template>

<script>
import MyTable from "@/components/Table";
import AddPosition from "../position_center/AddPosition.vue";
import AddCustomer from "../customer_center/AddCustomer.vue";
import { provinceAndCityData } from "element-china-area-data";
import addCardList from "./addCardList";
import { GetUnlimitedQRCodeMinix } from "@/utils/mixin";
import IDCard from "china-id-card";
import { baseUrl } from "../../request/url";
import QRCode from "qrcodejs2";

import InputNumberRange from "../../components/InputNumberRange.vue";
export default {
  components: {
    MyTable,
    AddPosition,
    AddCustomer,
    InputNumberRange,
    addCardList,
  },
  mixins: [GetUnlimitedQRCodeMinix],
  props: {
    users: Array,
    title: String,
    drawerShow: Boolean,
    operation: String,
    customerInfo: Object,
    industryData: Array,
    bankInfoList: Array,
    //0:普通人员  1.信用卡新增人员开卡 2.工资卡新增人员开卡
    type: String,
    visible: {
      default: false,
      type: Boolean,
      require: true,
    },
    row: {
      default: () => {
        return {};
      },
      type: Object,
      require: true,
    },
  },
  data () {
    let validatePhone = (rule, value, callback) => {
      //使用正则表达式进行验证手机号码
      if (!value) {
        callback();
      }
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("手机号不正确"));
      } else {
        callback();
      }
    };
    let validateIdcard = (rule, value, callback) => {
      //使用正则表达式进行验证手机号码

      if (!value) {
        callback();
      }
      if (IDCard(value).isVerified != true) {
        callback(new Error("身份证号码不正确"));
      } else {
        callback();
      }
    };

    let validateincome = (rule, value, callback) => {
      if (value == undefined) {
        callback();
        return;
      }
      if (value[0] == null && value[1] == null) {
        callback();
      }
      if (!value[0] || !value[1]) {
        callback(new Error("请输入完整"));
      } else {
        callback();
      }
    };
    let validatecardNum = (rule, value, callback) => {
      if (!value) {
        callback();
        return
      }
      var BIN = require("bankcardinfo");
      BIN.getBankBin(value, (err, data) => {
        if (!err) {
          this.bankName = data.bankName;
          callback();
        } else {
          this.bankName = "";
          callback(new Error("银行卡号不正确"));
        }
      });
    };
    let validateconPhone = (rule, value, callback) => {
      //使用正则表达式进行验证手机号码
      if (!value) {
        callback();
      }
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("手机号不正确"));
      } else if (value == this.form.tel) {
        callback(new Error("不能与手机号码相同"));
      } else {
        callback();
      }
    };
    return {
      bankName: "",
      searchList: [],
      addCustomerDrawerShow: false,
      options: provinceAndCityData,
      userId: "",
      id: "",
      employment: true,
      onerow: "",
      addPositionDrawerShow: false,
      tableHeight: "",
      drawerVisible: false,
      form: {
        img: [],
        isVeteran: false,
      },
      tableConfig: [
        {
          field: "openingBank",
          label: "开户银行",
          align: "center",
          minWidth: 120,
          flag: true,
        },

        {
          field: "cardNum",
          label: "银行卡号",
          align: "center",
          width: 180,
          flag: true,
        },
        {
          field: "openingBankName",
          label: "开户姓名",
          align: "center",
          minWidth: 90,
          flag: true,
        },
        {
          field: "isLogout",
          label: "状态",
          slotName: "isLogout",
          align: "center",
          minWidth: 90,
          flag: true,
        },
        {
          field: "tel",
          label: "平台开卡",
          slotName: "isOpenInPlatform",
          align: "center",
          width: 90,
          flag: true,
        },
        {
          field: "isDefault",
          label: "默认卡",
          align: "center",
          slotName: "isDefault",
          width: 180,
          flag: true,
        },
        {
          field: "imgPath",
          label: "银行卡照片",
          align: "center",
          slotName: "imgPath",
          width: 180,
          flag: true,
        },
        {
          field: "createUserName",
          label: "写入操作人",
          align: "center",

          width: 180,
          flag: true,
        },
        {
          field: "createDate",
          label: "写入时间",
          align: "center",

          width: 180,
          flag: true,
        },
        {
          field: "logoutUserName",
          label: "注销操作人",
          align: "center",

          width: 180,
          flag: true,
        },
        {
          field: "updateDate",
          label: "注销时间",
          align: "center",

          width: 180,
          flag: true,
        },
        {
          label: "操作",
          slotName: "operation",
          width: 240,
          fixed: "right",
          align: "right",
          flag: true,
        },
      ],
      BankList: [],
      selectloading: false,
      dialogVisible: false,
      loading: false,
      checkboxGroup: ["1"],
      tableData: [],
      currentPage: 1,
      addCardShow: false,
      isHideUpload: false,
      chooseFactoryId: "",
      total: 0,
      activeName: "first",
      submitLoading: false,
      drawer: false,
      companyScale: [],
      companyList: [],
      form: {
        identityCardBackPath: [],
        logo: [],
        identityCardFrontPath: [],
        electronicProtocol: [],
        imgPath: [],
        userOnJobRecord: {
          factoryId: '',
          factoryName: '',
          positionId: '',
          positionName: '',
          entryDate: '',
          tel: '',
          wages1: '',
          wages2: '',
          wages3: '',
          commission: '',
          bonus: '',
          deductMoney: '',
          wageCardNum: '',
          wageCardName: ''
        },
      },
      imgDialog: {
        show: false,
        imgUrl: "",
      },
      currentUserInfo: null,
      rules: {
        cardNum: [
          { required: true, message: "请输入银行卡号", trigger: "blur" },
          { validator: validatecardNum, trigger: ["blur"] },
        ],
        openingBankName: [
          { required: true, message: "请输入开户姓名", trigger: "blur" },
        ],

        'userOnJobRecord.positionId': [
          { required: true, message: "请选择职位", trigger: "blur" },
        ],
        'userOnJobRecord.factoryId': [
          { required: true, message: "请选择入职单位", trigger: "blur" },
        ],

        'userOnJobRecord.wages1': [{ required: true, message: "请输入工厂结算", trigger: "blur" }],
        'userOnJobRecord.wages2': [{ required: true, message: "请输入公司报价", trigger: "blur" }],
        'userOnJobRecord.wages3': [{ required: true, message: "请输入员工工资", trigger: "blur" }],
        'userOnJobRecord.tel': [{ required: true, message: "请输入员工入职手机号", trigger: "blur" }, { validator: validatePhone, trigger: "blur" },],
        wageCardNum: [{ required: false, trigger: "blur" }, { validator: validatecardNum, trigger: ["blur"] },],
        openingBank: [
          { required: true, message: "请输入开户银行", trigger: "blur" },
        ],
        userType: [
          {
            required: true,
            message: "请选择类型",
            trigger: ["change", "blur"],
          },
        ],
        createDate: [
          { required: true, message: "请选择注册时间", trigger: "blur" },
        ],
        cname: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        identityCard: [
          { required: true, message: "请输入身份证", trigger: "blur" },
          { validator: validateIdcard, trigger: "blur" },
        ],
        income: [{ validator: validateincome, trigger: "blur" }],
        tel: [
          {
            required: this.type == 1 ? true : false,
            message: "请输入手机号码",
            trigger: "blur",
          },
          { validator: validatePhone, trigger: "blur" },
        ],
        emergencyContactTel: [{ validator: validateconPhone, trigger: "blur" }],
        isInsder: [
          {
            required: true,
            message: "请选择是否为公司人员",
            trigger: ["change", "blur"],
          },
        ],
        isStore: [
          {
            required: true,
            message: "请选择是否有门店",
            trigger: ["change", "blur"],
          },
        ],
      },
      personForm: {},
      telFlag: false,
      remunerationType: '',
      invoiceForm: {},
      needInvoice: false,
      companyId: "00000000-0000-0000-0000-000000000000",
      basicinformationList: [
        {
          name: "博士",
        },
        {
          name: "研究生",
        },
        {
          name: "本科",
        },
        {
          name: "大专",
        },
        {
          name: "中专/职校",
        },
        {
          name: "高中",
        },
        {
          name: "初中及以下",
        },
      ],
      statusList: [
        {
          value: "待处理",
          num: 1,
        },
        {
          value: "待面试",
          num: 2,
        },
        {
          value: "面试未通过",
          num: 3,
        },
        {
          value: "待入职",
          num: 4,
        },
        {
          value: "未入职",
          num: 5,
        },
        {
          value: "已入职",
          num: 6,
        },
        {
          value: "已离职",
          num: 8,
        },
        {
          value: "已离职(自离)",
          num: 7,
        },
      ],
      customenContacts: [],
      tipVisible: false,
      positionList: [],
      sendData: {},
      baseUrl: baseUrl,
      toPage: "",
    };
  },
  computed: {
    isHideLogoUpload: function () {
      return this.form.logo.length == 1;
    },
    isHideIdCardFrontUpload: function () {
      return this.form.identityCardFrontPath.length == 1;
    },
    isHideIdCardBackUpload: function () {
      return this.form.identityCardBackPath.length == 1;
    },
    isHideimgPathUpload: function () {
      return this.form.imgPath.length == 1;
    },
  },
  mounted () {
    // this.getCompanyScaleData();
    console.log(this.form);

  },

  methods: {
    //薪资类型的判断
    remunerationTypeJudge () {
      if (this.remunerationType) {
        switch (this.remunerationType) {
          case '1' || 1:
            return '元/日';
          case '2' || 2:
            return '元/周';
          case '3' || 3:
            return '元/月';
          case '4' || 4:
            return '元/时';
          case '5' || 5:
            return '元/件';
          default:
            return '元';
        }
      }
      else {
        return '元';
      }
    },
    getBankList () {
      this.$api.manage.BankList().then((res) => {
        if (res.error === false) {
          this.BankList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    cardInput () {
      this.$set(this.form, "cardNum", this.form.cardNum.replace(/[^\d]/g, ""));
    },
    writeIdCard () {
      if (this.form.identityCard && this.form.identityCard[16]) {
        if (this.form.identityCard[16] % 2 == 1) {
          this.$set(this.form, "sex", "男");
        } else if (this.form.identityCard[16] % 2 == 0) {
          this.$set(this.form, "sex", "女");
        }
      }
    },
    closeDialog () {
      if (this.$shareType == 1) {
        this.bankInfoList.forEach((item) => {
          document.getElementById(item.bankName).innerHTML = "";
        });
      }
    },
    qrcode () {
      this.submitLoading = true;
      this.bankInfoList.forEach((item, i) => {
        if (this.$shareType == 1) {
          let qrcode = new QRCode(item.bankName, {
            width: 100, // 设置宽度，单位像素
            height: 100, // 设置高度，单位像素
            text:
              baseUrl.website +
              "/#/pages/webView/transferPage?id=" +
              item.bankAutoIntId +
              "-" +
              item.autoIntId +
              "-" +
              item.userAutoIntId +
              "-" +
              item.CompanyAutoIntId,
            // 设置二维码内容或跳转地址
          });
          console.log(
            baseUrl.website +
            "/#/pages/webView/transferPage?id=" +
            item.bankAutoIntId +
            "-" +
            item.autoIntId +
            "-" +
            item.userAutoIntId +
            "-" +
            item.CompanyAutoIntId
          );
          this.submitLoading = false;
        }
        if (this.$shareType == 2) {
          let sendData = {
            page: "pages/webView/transferPage",
            check_path: false,
            width: 150,
            scene:
              "id=" +
              item.bankAutoIntId +
              "-" +
              item.autoIntId +
              "-" +
              item.userAutoIntId +
              "-" +
              item.CompanyAutoIntId,
          };
          this.toPage = `${baseUrl.appletPage}?scene=${sendData.scene}`;
          this.GetUnlimitedQRCode(sendData).then((res) => {
            item.imgPath = "data:image/png;base64," + res;
            if (this.bankInfoList.length - 1 == i) {
              this.submitLoading = false;
            }
            this.tipVisible = true;
          });
        }
      });
    },
    addPersonnel () {
      this.$parent.noticeDialogVisible = true;
    },
    getCompanyList () {
      this.$api.customer.getAllCustomerList().then((res) => {
        if (res.error === false) {
          this.companyList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    chooseArea (v) {
      if (v) {
        this.$nextTick(() => {
          let areaTextArr = "";
          let arr = this.$refs["cascaderItem"].getCheckedNodes()[0].pathNodes;
          arr.forEach((i) => {
            areaTextArr = areaTextArr + i.label;
          });
        });
      }

      // this.form.nativePlace = areaTextArr;
    },
    handleChange () {
      this.$forceUpdate();
      this.positionList.forEach((item) => {
        if (item.id == this.form.entryPositionId) {

          this.form.standardName = item.standardName;
          this.form.occupationCode = item.occupationCode;
          this.$forceUpdate();
        } else if (item.id == this.form.userOnJobRecord.positionId) {
          this.remunerationType = item.remunerationType;
          this.$set(this.form, 'standardName', item.standardName)
          this.$set(this.form, 'occupationCode', item.occupationCode)
          this.$set(this.form.userOnJobRecord, 'wages1', item.wages1)
          this.$set(this.form.userOnJobRecord, 'wages2', item.wages2)
          this.$set(this.form.userOnJobRecord, 'wages3', item.wages3)
          this.$set(this.form.userOnJobRecord, 'commission', item.commission)
          this.$set(this.form.userOnJobRecord, 'bonus', item.bonus)
          this.$set(this.form.userOnJobRecord, 'deductMoney', item.deductMoney)
          this.$forceUpdate();

        }
      });
      console.log(this.form);

    },
    setDefault (row) {
      let sendData = {
        id: this.customerInfo.id,
        bankNo: row.cardNum,
        bankName: row.openingBank,
      };
      this.$api.user.UpdateDefaultBankInfo(sendData).then((res) => {
        if (res.error === false) {
          // this.$set(this.form, "defaultBankName", row.openingBank);
          // this.$set(this.form, "defaultBankNo", row.cardNum);
          this.$message.success("设置成功");
          this.getTalentList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    PositionList () {
      let sendData = {
        customerId: this.form.entryFactoryId || this.form.userOnJobRecord.factoryId,
      };
      this.selectLoading = true;
      this.form.entryPositionId = "";
      if (this.form.userOnJobRecord) {
        this.form.userOnJobRecord.positionId = "";
      }
      this.positionList = [];
      if (!sendData.customerId) {
        return;
      }
      this.$api.posts.PositionAllList(sendData).then((res) => {
        this.selectLoading = false;

        if (res.error === false) {
          this.positionList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    addAccount () {
      this.dialogVisible = true;
      this.$set(this.form, "openingBankName", this.form.cname);
      // this.form.openingBankName = this.form.cname;
    },
    clearSearchList () {
      this.searchList = [];
    },
    GetUserListByKeyWord (e) {
      this.selectloading = true;
      if (e != "") {
        setTimeout(() => {
          this.$api.user.GetUserListByKeyWord(e).then((res) => {
            console.log(res);
            if (res.error === false) {
              this.searchList = res.data;
              this.selectloading = false;
            }
          });
        }, 300);
      }
    },
    // getCard(id) {
    //   this.$api.user.UserCardPage(id).then((res) => {
    //     if (!res.error) {
    //       console.log(res);
    //       this.loading = false;
    //       this.tableData = res.data.data;
    //       this.total = res.data.count;
    //     }
    //   });
    // },

    open (row) {
      this.$set(this.form, "openingBank", row.openingBank);
      this.$set(this.form, "openingBankName", row.openingBankName);
      this.$set(this.form, "cardNum", row.cardNum);
      this.id = row.id;
      this.dialogVisible = true;
    },
    deleteCustomer (row) {
      this.$confirm("是否注销？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // let sendData = {
          //   id: row.id,
          // };
          this.submitLoading = true;
          let sendData = new FormData();
          sendData.append("userCardId", row.id);
          this.$api.user.Logout(sendData).then((res) => {
            this.submitLoading = false;
            if (res.error === false) {
              this.getTalentList();
              this.$message.success("注销成功");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => { });
    },
    imgEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;

        if (this.bankName && this.bankName != this.form.openingBank) {
          this.$confirm(
            `您选择的开户银行${"(" + this.form.openingBank + ")"
            }与您输入的银行卡${"(" + this.bankName + ")"}不匹配，是否继续新增?`,
            "提示",
            {
              confirmButtonText: "确 定",
              cancelButtonText: "取 消",
              type: "warning",
            }
          )
            .then(() => {
              this.addCar();
            })
            .catch(() => { });
        } else {
          this.addCar();
        }
      });
    },
    addCar () {
      this.submitLoading = true;
      let sendData = {
        userId: this.customerInfo.userId,
        cardNum: this.form.cardNum,
        openingBank: this.form.openingBank,
        openingBankName: this.form.openingBankName,
        imgPath: this.form.imgPath[0]?.url || "",
      };
      this.$api.user.UserCardEdit(sendData).then((res) => {
        if (res.error === false) {
          this.dialogVisible = false;
          // if (this.tableData == null || this.tableData.length == 0) {
          //   this.setDefault({ id: res.data });
          // }
          this.getTalentList();
          this.$message.success("新增成功");
        } else {
          this.$message.error(res.msg);
        }
        this.submitLoading = false;
      });
    },
    handleClick (tab, event) {
      // console.log(tab, event);
    },
    validateForm (formName) {
      let isValidate = false;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          isValidate = true;
        } else {
          isValidate = false;
        }
      });
      return isValidate;
    },
    getTalentList () {
      this.loading = true;
      let Data = "";
      let sendData = {};
      this.$nextTick(() => {
        sendData = {
          pageIndex: this.$refs.pagination.currentPage,
          pageSize: this.$refs.pagination.pageSize,
          userId: this.customerInfo.userId,
        };

        this.$api.user.UserCardPage(sendData).then((res) => {
          this.loading = false;
          if (!res.error) {
            console.log(res);
            this.tableData = res.data.data;
            this.total = res.data.count;
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    resetForm (formNmae) {
      this.form.openingBank = "";
      this.form.cardNum = "";
      this.form.openingBankName = "";
      this.form.imgPath = [];

      this.$refs[formNmae].clearValidate();
    },
    onSubmit () {
      if (!this.validateForm("form")) {
        this.$message.warning("填写信息有误，请检查表单");
        return;
      }
      if (this.needInvoice) {
        if (!this.validateForm("invoiceForm")) return;
      }
      console.log(this.form);
      let sendData = {
        cname: this.form.cname,
        ename: this.form.ename,
        identityCard: this.form.identityCard,
        nickName: this.form.nickName,
        createDate: this.form.createDate,
        tel: this.form.tel,
        sex: this.form.sex,
        isInsder: this.form.isInsder,
        isStore: this.form.isStore,
        selfImagePath: this.form.logo[0]?.url || "",
        identityCardFrontPath: this.form.identityCardFrontPath[0]?.url || "",
        identityCardBackPath: this.form.identityCardBackPath[0]?.url || "",
        userType: this.form.userType,
        parentId: this.form.parentId,
        address: this.form.address,
        isVeteran: this.form.isVeteran,
        isStudent: this.form.isStudent,
        occupationCode: this.form.occupationCode,
        standardName: this.form.standardName,
        remark: this.form.remark,
        emergencyContact: this.form.emergencyContact,
        emergencyContactTel: this.form.emergencyContactTel,
        basicinformation: this.form.basicinformation,
        permanentResidence: this.form.permanentResidence,
        nativePlace: this.form.nativePlace && this.form.nativePlace.toString(),
        wordUnit: this.form.wordUnit,
        unitAddress: this.form.unitAddress,
        income: this.form.income && this.form.income.toString(),
        entryPosition: this.form.entryFactoryId || this.form.userOnJobRecord.factoryId
          ? this.$refs.entryPositionId.selected.label
          : null,
        defaultBankNo: this.form.defaultBankNo,
        defaultBankName: this.form.defaultBankName,
        entryPositionId: this.form.entryPositionId
          ? this.form.entryPositionId
          : null,
        state: this.form.state,
        entryDate: this.form.entryDate,
        entryFactory: this.form.entryFactoryId ? this.$refs.entryFactoryId.selected.label : null,
        entryFactoryId: this.form.entryFactoryId
          ? this.form.entryFactoryId
          : null,
      };

      if (this.operation == "edit") {
        this.submitLoading = true;
        sendData.id = this.userId;
        this.$api.user.CompanyUserListEdit(sendData).then((res) => {
          console.log(sendData);
          console.log(res);
          if (res.error === false) {
            this.$message.success("保存成功");
            this.$emit("refreshData");
          } else {
            this.$message.error(res.msg);
          }
          this.submitLoading = false;
          // this.$refs["form"].resetFields();
          // this.$refs["invoiceForm"].resetFields();
          this.colseDrawer();
          if (this.$refs.form) {
            this.$refs.form.clearValidate();
          }
          // console.log("error=false");
        });
      } else {
        if (this.type == 0) {
          //判断是否同步入职
          if (this.employment) {
            sendData.userOnJobRecord = this.form.userOnJobRecord;
            sendData.entryDate = this.form.userOnJobRecord.entryDate
            sendData.userOnJobRecord.positionName = this.$refs.entryPositionId.selected.label
            sendData.userOnJobRecord.factoryName = this.$refs.entryFactoryId.selected.label
            sendData.entryFactoryId = this.form.userOnJobRecord.factoryId;
            sendData.entryPositionId = this.form.userOnJobRecord.positionId;
            sendData.userOnJobRecord.state = 6;
          }
          this.submitLoading = true;
          this.$api.user.CompanyUserListEdit(sendData).then((res) => {
            if (res.error === false) {
              if (this.type == 0) {
                // this.$message.success("保存成功");
                // this.$emit("refreshData");
                this.$confirm("新增成功！是否新增银行卡？", "提示", {
                  confirmButtonText: "确 认",
                  cancelButtonText: "关 闭",
                  type: "warning",
                })
                  .then(() => {
                    this.addCardShow = true;
                    this.onerow = {
                      id: res.data.companyUserId,
                      cname: this.form.cname,
                      userId: res.data.userId,
                    };
                    this.submitLoading = false;
                    this.colseDrawer();
                    this.$refs.form.clearValidate();
                    this.$emit("refreshData");
                  })
                  .catch(() => {
                    this.submitLoading = false;
                    this.colseDrawer();
                    this.$refs.form.clearValidate();
                    this.$emit("refreshData");
                  });
              } else {
                let arry = [res.data.userId];
                this.confirm(arry);
                this.submitLoading = false;
                this.colseDrawer();
                this.$refs.form.clearValidate();
              }
            } else {
              this.$message.error(res.msg);
            }
            // this.submitLoading = false;
            // this.colseDrawer();
            // this.$refs.form.clearValidate();
          });
          // });
        } else {
          if (this.$shareType == 1) {
            this.tipVisible = true;
          }
          this.$nextTick(() => {
            this.qrcode();
          });
          this.sendData = sendData;
        }
      }
    },
    sendNotic () {
      this.submitLoading = true;
      this.$api.user.CompanyUserListEdit(this.sendData).then((res) => {
        if (res.error === false) {
          if (this.type == 0) {
            this.$message.success("保存成功");
            this.$emit("refreshData");
            this.colseDrawer();
          } else {
            let arry = [res.data.userId];
            this.confirm(arry);
          }
        } else {
          this.submitLoading = false;

          this.$message.error(res.msg);
        }
        // this.$refs["form"].resetFields();
        // this.$refs["invoiceForm"].resetFields();
        this.$refs.form.clearValidate();
      });
    },
    confirm (userIdList) {
      let sendData = {
        id: this.$route.query.id,
        carType: this.type,
        userIdList: userIdList,
        bankInfoList: this.bankInfoList,
        msgType: this.checkboxGroup.join(),
        toPage: this.toPage,
      };
      this.$api.user.CompanyReferrerCarAdd(sendData).then((res) => {
        if (res.error === false) {
          this.$message.success("通知成功");
          this.submitLoading = false;
          this.tipVisible = false;
          this.$parent.noteCard();
          this.colseDrawer();
          console.log(res);
        } else {
          this.$message.error(res.msg);
          this.submitLoading = false;
        }
      });
      this.colseDrawer();
    },
    uploadimgPath (fileObj) {
      this.submitLoading = true;

      if (fileObj.file.size > 1024 * 1024 * 10) {
        this.$refs.uploadimgPath.clearFiles();
        this.$message.warning(
          "文件不符合规则（图片大小不超过 10M），请重新上传~"
        );
        this.submitLoading = false;

        return;
      }
      this.uploadSingleImage(fileObj, "imgPath");
    },
    uploadComapnayLogo (fileObj) {
      this.submitLoading = true;

      if (fileObj.file.size > 1024 * 1024 * 10) {
        this.$refs.uploadComapnayLogo.clearFiles();
        this.$message.warning(
          "文件不符合规则（图片大小不超过 10M），请重新上传~"
        );
        this.submitLoading = false;

        return;
      }

      this.uploadSingleImage(fileObj, "logo");
    },
    uploadIdCardFont (fileObj) {
      this.submitLoading = true;

      if (fileObj.file.size > 1024 * 1024 * 10) {
        this.$refs.uploadIdCardFont.clearFiles();
        this.$message.warning(
          "文件不符合规则（图片大小不超过 10M），请重新上传~"
        );
        this.submitLoading = false;

        return;
      }
      this.uploadSingleImage(fileObj, "identityCardFrontPath");
    },
    uploadIdCardBack (fileObj) {
      this.submitLoading = true;

      if (fileObj.file.size > 1024 * 1024 * 10) {
        this.$refs.uploadIdCardBack.clearFiles();
        this.$message.warning(
          "文件不符合规则（图片大小不超过 10M），请重新上传~"
        );
        this.submitLoading = false;

        return;
      }

      this.uploadSingleImage(fileObj, "identityCardBackPath");
    },
    uploadSingleImage (fileObj, imgType) {

      this.$api.upload
        .uploadSingleImage(fileObj.file)
        .then((res) => {
          this.submitLoading = false;

          if (res.code === 0) {
            this.$set(this.form[imgType], 0, {
              name: fileObj.file.name,
              url: res.data[0],
            });
            if (imgType == "identityCardFrontPath") {
              this.OcrIdCard(res.data[0], "front");
            } else if (imgType == "identityCardBackPath") {
              this.OcrIdCard(res.data[0], "back");
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((error) => {
          this.submitLoading = false;

          if (error.response?.status == 400) {
            this.$message.warning("请上传jpg、png格式的图片");
            this.form[imgType] = [];
          }
        });
    },

    //百度识别身份证
    OcrIdCard (url, idCardSide) {
      let sendData = {
        idCardSide: idCardSide,
        httpUrl: "https:" + url,
      };
      this.$api.thirdyParty.OcrIdCard(sendData).then((res) => {
        this.submitLoading = false;
        if (res.code === 0) {
          if (idCardSide == "front") {
            this.$set(this.form, "cname", res.data.username);
            this.$set(this.form, "sex", res.data.sex);
            this.$set(this.form, "permanentResidence", res.data.address);
            this.$set(this.form, "identityCard", res.data.idcardNo);
          }
        } else if (res.code == 4) {
          this.$message.error("请上传正确的身份证");
          if (idCardSide == "front") {
            this.removeUploadIdCardFront();
          } else {
            this.removeUploadIdCardBack();
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    onExceed (files, fileList) {
      this.$message.warning("只允许上传一张图片，请移除已上传图片后再进行操作");
    },
    onPreview (file) {

      this.imgDialog.show = true;
      this.imgDialog.url = file.url;
    },
    removeUploadLogo () {
      this.form.logo = [];
    },
    removeUploadIdCardFront () {
      this.form.identityCardFrontPath = [];
    },
    removeUploadIdCardBack () {
      this.form.identityCardBackPath = [];
    },
    removeUploadimgPath () {
      this.form.imgPath = [];
    },
    removeUploadLicense () {
      this.form.license = [];
    },
    removeUploadProtocol () {
      this.form.electronicProtocol = [];
    },
    colseDrawer () {
      this.$emit("colseDrawer");
      this.$emit("refreshData");
      this.activeName = "first";
      this.form.logo = [];
      this.form.identityCardBackPath = [];
      this.form.identityCardFrontPath = [];

      // this.$refs.form.clearValidate();
    },

    getUserDetails (id) {
      return new Promise((resolve, reject) => {
        this.$api.user.UserDetail(id).then((res) => {
          // console.log(res);
          if (res.error === false) {
            resolve(res.data);
          } else {
            reject("error");
          }
        });
      });
    },
    turnNum (nums) {
      if (nums == ",") {
        return;
      }
      return nums.map(Number);
    },
    fillFormData (customerInfo) {
      if (customerInfo.parentId) {
        this.getUserDetails(customerInfo.parentId).then((res) => {
          if (res) {
            this.searchList = [];
            this.searchList.push(res);
          }
        });
      }
      this.form.logo = [];
      this.form.identityCardBackPath = [];
      this.form.identityCardFrontPath = [];
      this.companyId = customerInfo.id;
      this.userId = customerInfo.id;
      const PrincipalId =
        customerInfo.PrincipalId == "00000000-0000-0000-0000-000000000000"
          ? ""
          : customerInfo.PrincipalId;
      // 基本信息

      this.getTalentList();
      this.$set(this.form, "cname", customerInfo.cname);
      this.$set(this.form, "ename", customerInfo.ename);
      this.$set(this.form, "identityCard", customerInfo.identityCard);
      this.$set(this.form, "nickName", customerInfo.nickName);
      this.$set(this.form, "userType", customerInfo.userType);
      this.$set(this.form, "createDate", customerInfo.createDate);
      this.$set(this.form, "tel", customerInfo.tel);
      this.$set(this.form, "sex", customerInfo.sex);
      this.$set(this.form, "isInsder", customerInfo.isInsder);
      this.$set(this.form, "isStore", customerInfo.isStore);
      this.$set(this.form, "parentId", customerInfo.parentId);
      this.$set(this.form, "openId", customerInfo.openId);
      this.$set(this.form, "address", customerInfo.address);
      this.$set(this.form, "isVeteran", customerInfo.isVeteran);
      this.$set(this.form, "isStudent", customerInfo.isStudent);
      this.$set(this.form, "entryDate", customerInfo.entryDate);
      this.$set(this.form, "state", customerInfo.state);
      this.$set(this.form, "defaultBankName", customerInfo.defaultBankName);
      this.$set(this.form, "defaultBankNo", customerInfo.defaultBankNo);
      if (customerInfo.tel) {
        this.telFlag = true;
      }
      this.$set(
        this.form,
        "entryFactoryId",
        customerInfo.entryFactoryId == "00000000-0000-0000-0000-000000000000"
          ? ""
          : customerInfo.entryFactoryId
      );
      if (customerInfo.entryFactoryId) {
        this.PositionList();
      }
      this.$set(
        this.form,
        "entryPositionId",
        customerInfo.entryPositionId
      );
      this.$set(this.form, "emergencyContact", customerInfo.emergencyContact);
      this.$set(
        this.form,
        "emergencyContactTel",
        customerInfo.emergencyContactTel
      );
      this.$set(this.form, "basicinformation", customerInfo.basicinformation);
      this.$set(
        this.form,
        "permanentResidence",
        customerInfo.permanentResidence
      );
      this.$set(
        this.form,
        "nativePlace",
        customerInfo.nativePlace && customerInfo.nativePlace.split(",")
      );
      this.$set(this.form, "wordUnit", customerInfo.wordUnit);
      this.$set(this.form, "unitAddress", customerInfo.unitAddress);
      if (customerInfo.income != ",") {
        this.$set(
          this.form,
          "income",
          customerInfo.income && this.turnNum(customerInfo.income.split(","))
        );
      } else {
        this.$set(this.form, "income", [null, null]);
      }
      this.$set(this.form, "remark", customerInfo.remark);

      customerInfo.selfImagePath &&
        this.form.logo.push({
          name: "企业LOGO",
          url: customerInfo.selfImagePath,
        });
      customerInfo.identityCardFrontPath &&
        this.form.identityCardFrontPath.push({
          url: customerInfo.identityCardFrontPath,
        });
      customerInfo.identityCardBackPath &&
        this.form.identityCardBackPath.push({
          url: customerInfo.identityCardBackPath,
        });
    },

    getUserInfo () {
      const memberId = JSON.parse(localStorage.getItem("Authorization"))
        ? JSON.parse(localStorage.getItem("Authorization")).memberId
        : "";
      if (!memberId) return;
      this.$api.user.getUserInfo(memberId).then((res) => {
        if (res.code === 0) {
          this.currentUserInfo = res.data;
        }
      });
    },
  },
  watch: {
    drawerShow (val) {
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
      if (val && this.operation == "edit") {
        this.getTalentList();
      }
      this.drawer = val;
      if (this.drawer == false) {
        this.companyId = "00000000-0000-0000-0000-000000000000";
        this.needInvoice = false;
        (this.form = {
          identityCardBackPath: [],
          logo: [],
          identityCardFrontPath: [],
          electronicProtocol: [],
          imgPath: [],
        }),
          this.$nextTick(() => {
            if (this.$refs.form) {
              this.$refs.form.clearValidate();
            }
          });
      }
      if (this.operation == "edit") {
        this.getCompanyList();
        this.getBankList();
        this.fillFormData(this.customerInfo);
      }
      if (this.operation == "add") {
        this.getCompanyList();

        // this.getBankList();
        this.telFlag = false;
        this.$set(this, "form", {});
        this.$set(this.form, "income", [null, null]);
        this.$set(this.form, "isVeteran", false);
        this.$set(this.form, "logo", []);
        this.$set(this.form, "imgPath", []);
        this.$set(this.form, "identityCardBackPath", []);
        this.$set(this.form, "identityCardFrontPath", []);
        this.$set(this.form, "userOnJobRecord", {
          factoryId: '',
          factoryName: '',
          positionId: '',
          positionName: '',
          entryDate: '',
          tel: '',
          wages1: '',
          wages2: '',
          wages3: '',
          commission: '',
          bonus: '',
          deductMoney: '',
          wageCardNum: '',
          wageCardName: ''
        });
      }
    },
  },
};
</script>

<style lang="less" >
.checkGroup {
  text-align: center;
  margin-top: 25px;

  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background-color: #409eff;
    border-color: #409eff;
  }
  .el-checkbox__label {
    display: initial;
  }
  .el-checkbox,
  .el-checkbox__input {
    display: initial;
  }
  .el-checkbox {
    margin-right: 10px;
  }
}
.hide-upload {
  .el-upload--picture-card {
    display: none !important;
  }
}
.create-talent-drawer {
  .el-upload--picture-card {
    width: 128px;
    height: 128px;
  }
  .avatar-uploader {
    img {
      width: 100px;
      height: 100px;
      border-radius: 50%;
      border: 1px solid #dcdfe6;
    }
  }
  .form-left {
    width: 65%;
    .avatar-box {
      display: flex;
      align-items: flex-end;
      margin-left: 80px;
      padding: 5px 0 20px 0;
    }
  }
  .form-right {
    width: 37%;
    margin-top: 175px;
    border-top: 1px solid #dcdfe6;
    margin-left: 25px;
    padding-top: 18px;
  }
  .formBox {
    border-top: 2px solid #dcdfe686;
    padding: 18px;
    // padding-bottom: 0;
  }
  .el-tabs__content {
    position: initial !important;
  }
  .remarkInput {
    width: 248%;
  }
  .el-drawer {
    width: 78% !important;
    min-width: 1170px;
    .el-drawer__body {
      height: 100% !important;
    }
    .el-tabs__content {
      height: 100%;
    }
    .el-tabs el-tabs--top {
      height: 900px !important;
    }
    .el-form el-form--inline {
      height: 100% !important;
    }
    .add-item-title {
      font-size: 16px;
      font-weight: bold;
      margin: 20px 0;
    }

    .el-drawer__header {
      border-bottom: 1px solid #eee;
      margin-bottom: 0;
      padding-bottom: 15px;
    }
    .el-drawer__body {
      padding: 17px 20px 0px 20px;
    }
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: auto;
  }
  .el-date-editor--daterange.el-input__inner {
    width: auto;
  }
  .el-date-editor .el-range-separator {
    width: 10%;
  }
  .base {
    width: 100%;
    position: relative;
    padding-bottom: 70px;
    .el-form-item {
      width: 48%;
      .el-form-item__content {
        width: 54%;
      }
      .el-select {
        width: 100%;
      }
    }
    .code-input {
      .el-form-item__content {
        width: calc(70% - 55px);
      }
    }
    .form-item-block {
      width: 100%;
      .el-form-item__content {
        width: 83%;
      }
    }
  }
  .submit-bar {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 10px 0;
    background-color: #fff;
    text-align: center;
    border-top: 1px solid #ddd;
    padding-right: 20px;
    .el-button {
      padding: 8px 20px;
    }
  }
  .hide-upload {
    .el-upload--picture-card {
      display: none !important;
    }
  }
}
</style>
